var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'app--dark':_vm.darkMode},attrs:{"id":"app"}},[(!_vm.loggedIn)?[_c('router-view')]:[(_vm.$mq === 'lg')?_c('Navigation'):_c('NavigationMobile'),_c('Page'),(_vm.$mq === 'lg')?_c('Social'):_vm._e()],_c('Modal')],2)}
var staticRenderFns = []

export { render, staticRenderFns }